// LAP-550 — Chip de variation +/- avec code couleur
import React from 'react'
import { Box } from '@mui/material'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { invTheme } from './theme'

export default function Delta({ value, unit = '%', size = 'sm', invert = false }) {
  if (value === undefined || value === null || isNaN(value)) return null
  const num = parseFloat(value)
  const isPositive = invert ? num < 0 : num >= 0
  const color = isPositive ? invTheme.positive : invTheme.negative
  const bg = isPositive ? invTheme.positiveSoft : invTheme.negativeSoft
  const sizes = {
    sm: { fontSize: 12, py: 0.25, px: 0.75 },
    md: { fontSize: 13, py: 0.4, px: 1 },
  }
  const sz = sizes[size] || sizes.sm
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        color,
        backgroundColor: bg,
        borderRadius: 999,
        fontWeight: 600,
        ...sz,
      }}
    >
      {num >= 0 ? (
        <ArrowDropUpIcon sx={{ fontSize: 16 }} />
      ) : (
        <ArrowDropDownIcon sx={{ fontSize: 16 }} />
      )}
      {num >= 0 ? '+' : ''}
      {Math.abs(num).toFixed(2)}
      {unit}
    </Box>
  )
}
